import axios from 'axios'
const baseUrl = 'http://106.14.46.221:7701'
const service = axios.create({
  baseURL: baseUrl,
  timeout: 50000,
  responseType: 'blob'
})
export default service
